const RE_ROUTE_VARIABLE = /\${(\w+)}/g;
module.exports = RE_ROUTE_VARIABLE;




// WEBPACK FOOTER //
// ./lib/rlink-router/RE_ROUTE_VARIABLE.js